import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { getSampleFiles, SamepleElements } from '../data/platform/sample_files_index';
import { Button } from 'react-bootstrap';

function CSVUploader({ combination_id, onFileUpload, onUpload1, onUpload2, selectedFile, selectedFile2 }) {
  const [sampleFileName1, setSampleFileName1] = useState(null);
  const [sampleFileName2, setSampleFileName2] = useState(null);
  const [sampleFile1, setSampleFile1] = useState(null);
  const [sampleFile2, setSampleFile2] = useState(null);

  let uploadedFile;
  let uploadedFile2;

  useEffect(() => {
    if (!sampleFileName1) {
      handleLoadSampleFiles();
    }
  }, [, sampleFileName1]);

  const handleLoadSampleFiles = async () => {
    const files = await getSampleFiles(combination_id);
    if (files !== null) {
      const [file_item1, file_item2] = files;

      setSampleFileName1(file_item1.name);
      setSampleFile1(file_item1);
      setSampleFileName2(file_item2.name);
      setSampleFile2(file_item2);
    }
  };

  const handleRunWithSample = async () => {
    setupFile1(sampleFile1);
    setupFile2(sampleFile2);
    onFileUpload();
  };

  const handleFileChange1 = (event) => {
    uploadedFile = event.target.files[0];
    if (check_file(uploadedFile)) {
      setupFile1(uploadedFile);
    } else {
      event.target.value = null; // Reset file input element value
    }
  };

  const setupFile1 = (_file) => {
    let filename = _file.name;
    filename = filename.split('/').pop();

    let binary_selectedFile;
    const fileReader = new FileReader();
    fileReader.readAsDataURL(_file);
    fileReader.onload = () => {
      if (fileReader !== null) {
        binary_selectedFile = fileReader.result;
      }
    };
    Papa.parse(_file, {
      header: true,
      complete: (result) => {
        onUpload1({ headerFields: result.meta.fields, file: binary_selectedFile, filename: filename });
      },
    });
  };

  const setupFile2 = (_file) => {
    let filename = _file.name;
    filename = filename.split('/').pop();
    let binary_selectedFile;
    const fileReader = new FileReader();
    fileReader.readAsDataURL(_file);
    fileReader.onload = () => {
      if (fileReader !== null) {
        binary_selectedFile = fileReader.result;
      }
    };
    Papa.parse(_file, {
      header: true,
      complete: (result) => {
        onUpload2({ headerFields: result.meta.fields, file: binary_selectedFile, filename: filename });
      },
    });
  };

  const handleFileChange2 = (event) => {
    uploadedFile2 = event.target.files[0];
    if (check_file(uploadedFile2)) {
      setupFile2(uploadedFile2);
    } else {
      event.target.value = null; // Reset file input element value
    }
  };

  const check_file = (file) => {
    const allowedTypes = ['text/csv'];

    if (!file) {
      alert('Please select a file');
      return;
    }

    const maxSize = 15 * 1024 * 1024; // 15 megabytes
    if (file && file.size > maxSize) {
      alert('File size too large');
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      alert('File type not supported');
      return;
    }
    return true;
  };

  return (
    <div>
      Choose invoice:
      <br />
      <input type="file" accept=".csv" onChange={handleFileChange1} />
      <br />
      <br />
      Choose Purchase Order:
      <br />
      <input type="file" accept=".csv" onChange={handleFileChange2} />
      <br />
      <small>Note: csv file format supported</small>
      <br />
      <Button
        variant="primary"
        type="submit"
        onClick={onFileUpload}
        className="mt-3 px-4"
        disabled={!selectedFile || !selectedFile2}
      >
        Load your CSV files
      </Button>
      <SamepleElements
        handleRunWithSample={handleRunWithSample}
        sampleFileName1={sampleFileName1}
        sampleFileName2={sampleFileName2}
      />
    </div>
  );
}

export default CSVUploader;
